import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

// Translations
import translate from '../Translate.js';

// Dependencies
import currencyFormatter from 'currency-formatter';

const OwedPayments = observer(class OwedPayments extends React.Component {
  render() {
    const { translation } = this.props;
    const { PaymentStore, SessionStore } = this.props.store;
    const { balance } = PaymentStore;
    const currency = SessionStore.defaultCurrency || 'USD';

    return (
      <article className="panel--medium">
        <header className="panel__header">
          <h2 className="panel__title">{translation.heading}</h2>
        </header>

        <div className="panel__content">
          <div className="panel__copy">
            <span className="panel__subhdg">{translation.owe}</span>

            <span className="text-code">
              {currencyFormatter.format(balance, {code: currency})}
            </span>

            <Link className="btn--outline" to="payments">{translation.button}</Link>
          </div>
        </div>
      </article>
    )
  }
})

export default translate('OwedPayments')(OwedPayments);


// WEBPACK FOOTER //
// ./src/app/components/Dashboard/OwedPayments.js